<template>
  <div class="inventory">
        <audio controls="controls" hidden src="../../../assets/err.mp3" ref="erraudio"></audio>
        <audio controls="controls" hidden src="../../../assets/success.wav" ref="successaudio"></audio>
        <van-tabs v-model="active" line-width="50%" line-height="2px" color="#29c727" @click="tabsClick">
            <van-tab title="按库位">
                <div class="location-box">
                    <div class="location-search">
                        <span>库位 </span><van-field size="small" v-model="search.locationCode" placeholder="库位" @keyup.13="locationKeyUp" @focus="locationFocus" @input="locationChange" right-icon="scan" @click-right-icon="scan('location','locationCode')"/>
                    </div>

                    <div class="location-count">
                        <span style="margin-right:10%;">SKU种类：{{total.productTotal || 0}}</span> <span>总计：{{total.inventoryTotal || 0}}</span>
                    </div>

                    <div class="location-details">
                        <ul>
                            <li class="details-top">
                                <span>SKU/数量</span>
                                <span>盘点数量</span>
                            </li>
                            <template v-if="list.length">
                                <li class="details-item" v-for="(item,index) in list" :key="index">
                                    <div class="item-top">
                                        <div class="item-left">
                                            <p>{{item.sku}}</p>
                                            <p>库位数量：{{list_Back[index].locationInventory || 0}}</p>
                                            <p>仓库数量：{{item.warehouseInventory || 0}}</p>
                                            <p>佰易总数量：{{item.hkeasyInventory || 0}}</p>
                                        </div>
                                        <div class="item-right">
                                            <input type="number" v-model="item.locationInventory"  @change="inputNumChange('locationInventory',index)">
                                        </div>
                                    </div>
                                    <div class="item-buttom"><span>异常原因：</span><input type="text" maxlength="50" v-model="item.remark"></div>
                                </li>
                            </template>
                            <template v-else>
                                <li class="details-item" style="text-align:center;color:#ccc;">
                                    暂无数据
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div class="submit-box" v-show="showSubmitBtn">
                        <button class="submit-btn" @click="submit('location')">保存</button>
                    </div>
                </div>
            </van-tab>
            <van-tab title="按SKU">
                <div class="sku-box">
                    <div><span>SKU </span><van-field size="small" v-model="skuSearch.productCode" placeholder="SKU" @focus="productCodeFocus" right-icon="scan" @click-right-icon="scan('sku','productCode')" @keyup.13="getSKUList"/></div>
                    <div><span>库位 </span><van-field size="small" v-model="skuSearch.locationCode" placeholder="库位" :disabled="skuLocationCodeDisabled" :style="skuLocationCodeDisabled?'background: #f7f6f8':''" @focus="locationFocusForSku"  @keyup.13="getSKUList" @input="locationChange" right-icon="scan" @click-right-icon="scan('sku','locationCode')"/></div>

                    <div class="sku-content">
                        <p>名称：{{skuList.productNameCN ? skuList.productNameCN : ''}}</p>
                        <p>WMS库存：{{skuList.warehouseInventory || 0}}</p>
                        <p>佰易库存：{{skuList.hkeasyInventory || 0}}</p>
                    </div>

                    <div>
                        <span>盘点数量 </span><input type="number" v-model="skuList.locationInventory" @focus="productCodeFocus" @change="inputSkuNumChange('locationInventory')">
                    </div>

                    <div style="white-space: nowrap;">
                        <span style="vertical-align: top;">异常说明 </span><textarea class="sku-area" @focus="productCodeFocus" maxlength="50"  v-model="skuList.remark"></textarea>
                    </div>
                    
                    <div class="submit-box" style="position:static;margin-top: 10%;" v-show="showSubmitBtn">
                        <button class="submit-btn" style="width: 100%;" @click="submit('sku')">保存</button>
                    </div>
                </div>

            </van-tab>
        </van-tabs>


        <van-popup v-model="showPicker" round position="bottom" :overlay="false">
			<van-picker
				show-toolbar
				confirm-button-text="确认"
				cancel-button-text="取消"
				:columns="columns"
				@cancel="showPicker = false"
                :loading="loading"
				@confirm="onConfirm"
                :item-height="30"
                :visible-item-count="5"
			/>
		</van-popup>
  </div>
</template>

<script>
import { Icon, Badge, Picker, Popup, Field, Tab, Tabs,Toast } from 'vant';
import { getLocationStockTakingList, getSKUStockTakingList, getStockTakingtotal, addStockTaking, getSkuStock } from '@/api/mobile/inventory_api';
import { getWarehouseLocation } from '@/api/mobile/stock_api';
import { mapState } from 'vuex'
import { mixins } from "../mobileMixins";

export default {
  data() {
    return {
        showPicker: false,
        value: '',
        columns: [],
        submitData: {},
        active: 0,
        search: {
            page: 1,
            pageSize: 9999,
            warehouseId: '',
            locationCode: '',
        },
        list:[],
        list_Back:[],
        total:{},
        skuSearch: {
            warehouseId: '',
            locationCode: '',
            productCode: '',
        },
        isSku: false,
        skuList: {},
        skuList_Back: {},
        loading: false,
        skuLocationCodeDisabled: true,
        showSubmitBtn: true
    }
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Tab.name]: Tab,
    [Toast.name]: Toast,
    [Tabs.name]: Tabs
  },
  mixins: [mixins],
  created() {
    this.init()
  },
  mounted(){
    this.forPC()
  },
  computed: {
    ...mapState({ warehouse: state => state.common.warehouse ,changeShowFooter: state => state.common.showMobileFooter})
  },
  watch:{
        'skuSearch.productCode':function(o,n){
            if(!this.skuSearch.productCode) {
                this.skuLocationCodeDisabled = true
                this.$set(this.skuSearch,'locationCode','')
            }else{
                this.skuLocationCodeDisabled = false
            }
        },
        // changeShowFooter(n){
        //     this.showSubmitBtn = n
        // }
  },
  methods: {
    init(){
        const that = this
        const user = window.localStorage.user ? JSON.parse(window.localStorage.user) : null;
        const _warehouse = window.localStorage.warehouse ? JSON.parse(window.localStorage.warehouse) : this.warehouse;

        this.$set(this.search,'warehouseId',_warehouse.warehouseId)
        this.$set(this.skuSearch,'warehouseId',_warehouse.warehouseId)

        this.viewportHeight = window.innerHeight
        window.addEventListener('resize',function(){
            if(that.viewportHeight - this.innerHeight > 50){ // 键盘弹起
                if(that.focusType === 'storageName'){
                    that.showPicker = false
                }
            }else{ // 键盘收起
                if(that.focusType === 'storageName'){
                    that.showPicker = true
                }
            }
        },true)
    },

    scan(type,name){
        let that = this
        if(type === 'sku' && name === 'locationCode'){
            if(this.skuLocationCodeDisabled) return;
        }
        this.$wx.scanQRCode({
            needResult: 1,
            desc: 'scanQRCode desc',
            success: function (a) {
                const t = type === 'sku' ? 'skuSearch' : 'search'
                that.isSku= type === 'sku' ? true : false
                that.$set(that[t],name,a.resultStr)
                that.$nextTick(function(){
                    that.showPicker = false
                })
                if(!that.isSku){
                    that.list = []
                    that.list_Back = []
                    that.skuList = {}
                    that.skuList_Back = {}

                    that.getLocationList()
                    that.getStockTakingtotal()
                }else{
                    that.getSKUList()
                }
            }
        })
    },  

    onConfirm(val){
        if(!this.isSku){
            this.list = []
            this.list_Back = []
            this.skuList = {}
            this.skuList_Back = {}

		    this.$set(this.search, 'locationCode', val)
            this.getLocationList()
            this.getStockTakingtotal()
        }else{
		    this.$set(this.skuSearch, 'locationCode', val)
            this.getSKUList()
        }
		this.showPicker = false;
    },
    productCodeFocus(){
		this.focusType = 'productCode'
		this.showPicker = false;
    },

    locationFocus(){
		this.showPicker = true;
        this.isSku = false;
		this.focusType = 'storageName'
        this.locationChange();
    },

    locationFocusForSku(){
		this.showPicker = true;
        this.isSku = true;
		this.focusType = 'storageName'
        this.locationChange();
    },

    locationChange(){
        const {locationCode,warehouseId} = this.isSku ? this.skuSearch : this.search
        const data = {locationCode,warehouseId}

      	if(!locationCode) return
        
        this.loading = true
        getWarehouseLocation(data).then(res=>{
            this.loading = false
            if(res.status === 200 && res.response){
                const {response} = res
                this.warehouseList = response

                try{
                    let arr = []
                    response.forEach((item)=>{
                        arr.push(item.locationCode);
                    })
                    this.columns = arr
                }catch{}
            }else{
                Toast.fail(res.msg);
            }
        })
    },

    getLocationList(){
      
        getLocationStockTakingList(this.search).then(res=>{
            if(res.status === 200 && res.response.pageData.length){
                const {pageData} = res.response
                this.list = JSON.parse( JSON.stringify(pageData))
                this.list_Back = JSON.parse( JSON.stringify(pageData))
            }else{
                Toast.fail(res.msg);
            }
        })
    },
    getStockTakingtotal(){
         
        const {locationCode,warehouseId} = this.search
        const data = {
            locationCode,warehouseId
        }
        getStockTakingtotal(data).then(res=>{
            if(res.status === 200){
                const {response} = res
                this.total = response
            }else{
                Toast.fail(res.msg);
            }
        })
    },
    // getSkuStock(){
    //     const {productCode,warehouseId} = this.skuSearch
    //     const data = {
    //         productCode,warehouseId
    //     }
    //     if(!productCode){
    //         return
    //     }
    //     getSkuStock(data).then(res=>{
    //         if(res.status === 200 && res.success){
    //             this.skuLocationCodeDisabled = false
    //             // Toast.success(res.msg);
    //         }else{
    //             this.$set(this.skuSearch,'locationCode','')
    //             this.skuLocationCodeDisabled = true
    //             this.skuList = {}
    //             this.skuList_Back = {}
    //             Toast.fail(res.msg);
    //         }
    //     })
    // },
    getSKUList(){
        if(this.skuSearch.productCode!=""&&this.skuSearch.locationCode!=""){
            getSKUStockTakingList(this.skuSearch).then(res=>{
            if(res.status === 200 && res.response){
                const {response} = res
                this.skuList = JSON.parse( JSON.stringify(response))
                this.skuList_Back = JSON.parse( JSON.stringify(response))
            }else{
                this.skuList = {}
                this.skuList_Back = {}
                Toast.fail(res.msg);
            }
         })
        }
       
    },
    tabsClick(){
        this.showPicker = false
        this.forPC()
    },
     showsound(isSuccess){
      if(isSuccess)
      {
          this.$refs.successaudio.currentTime=0;
          this.$refs.successaudio.play();
      }
      else
      {
          this.$refs.erraudio.currentTime=0;
          this.$refs.erraudio.play();
      }
    },
    submit(type){
        const {warehouseId} = this.search
        let arr = []
        if(type === 'sku'){
            if(this.skuList.locationInventory != this.skuList_Back.locationInventory && !this.skuList.remark){
                 this.showsound(false);
                Toast('数量变动时请填写异常原因')
                return
            }
            if(this.skuList.remark && this.skuList.storageID){
                
                const {productInfoID,storageID,locationInventory} = this.skuList

                arr.push({
                    inventoryCheckID:0,  // 预留的字段
                    storageID,
                    productSKUID:productInfoID,
                    waitCheckQty:this.skuList_Back.locationInventory,
                    actualCheckQty:locationInventory,
                    remark:this.skuList.remark
                    })
            }
            
        }else{
            for (let i = 0; i < this.list.length; i++) {
                const row = this.list[i]
                if(row.locationInventory != this.list_Back[i].locationInventory && !row.remark){
                    this.showsound(false);
                    Toast('数量变动时请填写异常原因')
                    return
                }
                if(row.remark){
                        
                    const {productInfoID,storageID,locationInventory} = row

                    arr.push({
                        inventoryCheckID:0,
                        storageID,
                        productSKUID:productInfoID,
                        waitCheckQty:this.list_Back[i].locationInventory,
                        actualCheckQty:locationInventory,
                        remark:row.remark
                        })
                }
            }
        }
        if(arr.length === 0){
            this.showsound(false);
            Toast('没有要提交的更改')
            return
        }
        const data = {
            warehouseID:warehouseId,
            check:arr
        }

        Toast.loading({
            message: '保存中...',
            forbidClick: true,
        });

        addStockTaking(data).then(res=>{
			Toast.clear();
            if(res.status === 200 && res.success){
                this.showsound(true);
                type === 'sku' ? this.getSKUList() : this.locationKeyUp()
                Toast.success(res.msg);
            }else{
                this.showsound(false);
                Toast.fail(res.msg);
            }
        })
    },
    locationKeyUp(){
      
        this.getLocationList()
        this.getStockTakingtotal()
    },
   
    inputNumChange(field,index) {
        let num = Number(this.list[index][field])
        const n = this.list_Back[index][field]
        if(num < 0){
            this.showsound(false);
            Toast('请输入正整数')
            num = Number(0)
        }
        this.$set(this.list[index],field,parseInt(num))
    },
    inputSkuNumChange(field) {
        let num = Number(this.skuList[field])
        const n = this.skuList_Back[field]
        if(num < 0){
            this.showsound(false);
            Toast('请输入正整数')
            num = Number(0)
        }
        this.$set(this.skuList,field,parseInt(num))
    },
  }
}
</script>

<style lang="less" scoped>
    ::v-deep .van-cell{
        border: 1px solid #adadad;
        margin-bottom: 7px;
        padding: 5px 10px;
        width: 86%;
        display: inline-block;
        vertical-align: middle;
    }
    ::v-deep .van-tabs__line {
        background-color: #29c727;
    }
    .inventory {
        background-color: #fbf9fe;
    }
    .inventory .location-box {
        padding: 10px 10px 60px 10px;
        box-sizing: border-box;
        .location-search{
            white-space: nowrap;
            text-align: center;
            span{
                font-size: 20px;
            }
        }
        .location-count{
            font-size: 15px;margin: 10px 0;
        }
        .location-details{
            .details-top{
                border: 1px solid #ccc;
                span:first-child{
                    display: inline-block;
                    width: 60%;
                    text-align: center;
                    border-right: 1px solid #ccc;
                    box-sizing: border-box;
                    padding: 3px 0;
                }
                span:last-child{
                    display: inline-block;
                    width: 40%;
                    text-align: center;
                    box-sizing: border-box;
                    padding: 3px 0;
                }
            }
            .details-item{
                border: 1px solid #ccc;
                &{
                    border-top: 0;
                }
                .item-top{
                    border-bottom: 1px solid #ccc;
                    .item-left{
                        display: inline-block;
                        width: 60%;
                        box-sizing: border-box;
                        border-right: 1px solid #ccc;
                        font-size: 15px;
                        p{
                            margin: 5px 0;
                            text-align: center;
                        }
                    }
                    .item-right{
                        display: inline-block;
                        width: 40%;
                        box-sizing: border-box;
                        min-height: 100px;
                        display: inline-block;
                        vertical-align: bottom;
                        line-height: 100px;
                        text-align: center;
                        input{
                            width: 90%;
                            height: 20px;
                            line-height: 20px;
                            font-size: 14px;
                        }
                    }
                }
                .item-buttom{
                    padding: 2px;
                    display: flex;
                    flex-direction: row;
                    flex-wrap: nowrap;
                    input{
                        flex: 1;
                    }
                }
            }
        }
    }
    
    .submit-box{
        position: fixed;
        bottom: 9%;
        width: 100%;
        .submit-btn{
            width: 95%;
            height: 40px;
            border-radius: 5px;
            background-color: #169bd5;
            color: #fff;
            font-size: 15px;
            border: 0;
        }
    }
    .inventory .sku-box{
        padding: 10px;
        box-sizing: border-box;
        .sku-content{
            p{
                margin: 5px 0;
            }
        }
        div{
            margin: 10px 0;
            .sku-area{
                width: 75%;
            }
        }
    }
    .disabled{
        background: #f7f6f8;
    }
</style>